import React from 'react';

import { Tooltip } from 'antd';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { selectServiceInfos, selectStatusInfo } from '../../../store/serviceCalendarSlice';
import { formatTooltipText } from '../../../utils/helpFuntion';

export const ServiceCalendarPopupShowColors = ({ type }) => {
    const isStatus = type === 'status';
    const infos = useSelector(isStatus ? selectStatusInfo : selectServiceInfos);

    if (!infos || infos.length === 0) {
        return <div className="search-status-body">Loading legend...</div>;
    }

    return (
        <div className="search-status-body">
            {infos.map((info, index) => (
                <Tooltip
                    key={info.type || index}
                    title={
                        <>
                            <div style={{ color: info.textColor, fontWeight: 'bold', marginBottom: '5px', fontSize: '15px' }}>{info.type}</div>
                            <div style={{ color: isStatus ? 'black' : 'white' }}>{formatTooltipText(info.tooltipText)}</div>
                        </>
                    }
                    color={info.backgroundColor}
                    styles={{
                        body: { padding: '8px 6px' }
                    }}
                    placement="left">
                    <div
                        style={{
                            padding: isStatus ? '3px 4px' : '2px 3px',
                            marginTop: '3px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            background: info.backgroundColor,
                            border: (isStatus ? '1px solid ' : '2px solid ') + info.borderColor,
                            color: info?.textColor,
                            fontWeight: 'bolder',
                            cursor: 'pointer',
                            boxSizing: 'border-box'
                        }}>
                        {info.type}
                    </div>
                </Tooltip>
            ))}
        </div>
    );
};

ServiceCalendarPopupShowColors.propTypes = {
    type: PropTypes.oneOf(['status', 'service']).isRequired
};
